<script setup lang="ts">
interface Props {
  message?: string
}

const props = withDefaults(defineProps<Props>(), {
  message: '',
})

onMounted(() => {
  const notification = document.body.querySelector('.notification')
  if (notification === null) return
  notification.addEventListener('animationend', function () {
    // remove the Notifiaction from DOM after animation ends
    notification.remove()
  })
})
</script>

<template>
  <div class="notification">
    {{ props.message }}
  </div>
</template>

<style scoped>
.notification {
  padding: 1rem 2rem;
  border: none;
  background: red;
  color: white;
  font-weight: 900;
  font-size: 1rem;
  text-align: center;
  border-radius: 50px;
  opacity: 1;
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 999;
  animation: move 8s forwards;
}

@keyframes move {
  0% {
    transform: translateX(100vw);
  }
  20%,
  80% {
    transform: translateX(-1rem);
  }
  100% {
    transform: translateX(100vw);
  }
}
</style>
